import { brokerUrl } from 'common/useRouterArea';
import { brokerBaseURL } from 'config';
import { useGetLoggedUserAsync } from 'features/auth/broker';
import { useEffect, useState } from 'react';
import { Outlet, useMatch, useNavigate } from 'react-router-dom';
import { storeNameBrokerAuth, useAuthBroker } from './useAuthBroker';

const BrokerRoute = () => {
  const [authed, setAuthed] = useState(!!useAuthBroker());
  const [loaded, setLoaded] = useState(authed === true);
  const isParentBroker = useMatch(brokerUrl);
  const navigate = useNavigate();

  const getAsync = useGetLoggedUserAsync();

  useEffect(() => {
    async function checkIfLoggedInBroker() {
      const user = await getAsync();
      setLoaded(true);
      setAuthed(user !== null);
      if (user !== null) {
        sessionStorage.setItem(storeNameBrokerAuth, JSON.stringify(user));
      }
    }

    if (isParentBroker) {
      navigate('/', { replace: true });
    } else if (!loaded) {
      checkIfLoggedInBroker();
    }
  }, [isParentBroker, getAsync, loaded, navigate]);

  if (!loaded) {
    return <div>Authenticating...</div>;
  }

  if (!authed) {
    document.location.href = `${brokerBaseURL}/broker/login`;
    return <div>Redirecting...</div>;
  }

  return <Outlet />;
};

export default BrokerRoute;
